import { render } from "./telegram.vue?vue&type=template&id=1b27e280"
const script = {}

import exportComponent from "D:\\Dev\\Personal\\reethi-inertia\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__